import request from '@utils/request';
import { IEnumItem, IPositionList, IPositionDetail, IShareInfo } from '@src/types';
import { LxSiteClick, lxSearchClickInfo } from '@utils/siteLx';
import { custom } from '@src/utils/siteLx';

// 获取城市列表
export async function getCityList(params): Promise<IEnumItem[]> {
  const res = await request.post('/api/official/city/search', params);
  return res;
}

export async function getEnCityList() {
  try {
    const res = await request.post(`/api/official/en/city/search`);
    return res;
  } catch (e) {
    return [];
  }
}

// 职位搜索条件相关枚举 JF--JobFamily  BG--事业部枚举值  HIRING--招聘类型 ?enumType=${enumType}
export async function getEnumsByType(enumType): Promise<IEnumItem[]> {
  const res = await request.get(`/api/official/job/search/enum?enumType=${enumType}`);
  return res;
}

// 职位列表
export async function getJobList(params): Promise<IPositionList> {
  const {
    page: { pageNo },
    keywords,
  } = params;
  const pathname = window.location.pathname.replace('/web', '');
  /* eslint-disable */
  if (pageNo === 1) {
    const lxClickInfo = lxSearchClickInfo(pathname);
    LxSiteClick({
      bid: lxClickInfo?.bid,
      valLab: {
        query_keyword: keywords,
        entry_point: lxClickInfo?.entry,
      },
    });
  }
  const { u_query_id, r_query_id } = custom;
  const res = await request.post('/api/official/job/getJobList', { ...params, u_query_id, r_query_id });
  /* eslint-enable */
  return res;
}

// 职位详情
export async function getJobDetail(params): Promise<IPositionDetail> {
  const res = await request.post('/api/official/job/getJobDetail', params);
  return res;
}

// 获取伯乐信息和分享的职位 职位列表&校招、社招投递页
export async function getShareInfo(params): Promise<IShareInfo> {
  if (!params?.token) {
    params = {
      ...params,
      token: null,
    };
  }
  if (!params?.staffSsoId) {
    params = {
      ...params,
      staffSsoId: null,
    };
  }
  const res = await request.post('/api/official/job/getShareInfo', params);
  return res;
}

// 职位分享
export async function shareJob(params) {
  const res = await request.post<{ token: string }>('/api/official/job/share', params);
  return res;
}

// 获取意向数据枚举
export const getAspirationDirectionList = async (jobUnionId: string) => {
  const result = await request.post<any>(`/api/official/job/queryAspirationDirection?jobUnionId=${jobUnionId}`);
  return result;
};
